var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn",on:{"click":_vm.handleClick}},[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('img',{staticClass:"btn__arrow",attrs:{"src":require("../../../assets/coursePage/llm/common/arrow-right-up.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }